import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import TopBar from './TopBar'; // Impor komponen TopBar
import Footer from './Footer';
import FloatingWhatsAppButton from './FloatingWhatsAppButton'; // Impor komponen baru
import ScrollToTop from './ScrollToTop';

const Layout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (event) => {
      // Pintasan: Ctrl + Alt + A untuk ke halaman login admin
      if (event.ctrlKey && event.altKey && (event.key === 'a' || event.key === 'A')) {
        event.preventDefault(); // Mencegah aksi default browser
        console.log('Pintasan admin diaktifkan!');
        navigate('/admin');
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    // Membersihkan event listener saat komponen dilepas
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [navigate]);

  return (
    <div className="App">
      <TopBar /> {/* Tambahkan TopBar di sini */}
      <Navbar />
      <ScrollToTop />
      {/* Konten halaman akan dirender di sini */}
      <main>
        <Outlet />
      </main>
      <Footer />
      <FloatingWhatsAppButton /> {/* Tambahkan komponen di sini */}
    </div>
  );
};

export default Layout;